import './HowItWorks.css'

export default function HowItWorks() {
  return (
    <div className='HowItWorks-container'>
      <div className='HowItWorks-title-banner'>
        <h2>HOW IT WORKS</h2>
      </div>

      <div className='HowItWorks-steps'>
        <div className='HowItWorks-step'>
          <div className='HowItWorks-step-icon'>
            <img src='/ccl_userflow_1.png' alt='Book' />
          </div>
          <h3>Book</h3>
          <p>
            Schedule your laundry service online,
            <br />
            and we will contact you right after
            <br />
            your booking is complete.
          </p>
        </div>

        <div className='HowItWorks-step'>
          <div className='HowItWorks-step-icon'>
            <img src='/ccl_userflow_2.png' alt='Pickup' />
          </div>
          <h3>Pickup</h3>
          <p>
            Our driver collects your laundry
            <br />
            at your chosen time.
          </p>
        </div>

        <div className='HowItWorks-step'>
          <div className='HowItWorks-step-icon'>
            <img src='/ccl_userflow_3.png' alt='Wash' />
          </div>
          <h3>Wash</h3>
          <p>
            We wash, dry, and
            <br />
            fold everything with care.
          </p>
        </div>

        <div className='HowItWorks-step'>
          <div className='HowItWorks-step-icon'>
            <img src='/ccl_userflow_4.png' alt='Delivery' />
          </div>
          <h3>Delivery</h3>
          <p>
            Fresh, clean laundry returned
            <br />
            right to your door.
          </p>
        </div>
      </div>
    </div>
  )
}
